import { render } from "./IconNavigationBar.vue?vue&type=template&id=dffb5910&scoped=true&ts=true"
import script from "./IconNavigationBar.vue?vue&type=script&lang=ts"
export * from "./IconNavigationBar.vue?vue&type=script&lang=ts"

import "./IconNavigationBar.vue?vue&type=style&index=0&id=dffb5910&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dffb5910"]])

export default __exports__